import { makeVar, useReactiveVar } from '@apollo/client';
import { SurfaceNodeUnion } from 'graphql/types';

export interface SideDrawerState {
  node?: SurfaceNodeUnion;
}

interface SideDrawerOperations {
  setNodeToDrawer: (node: SurfaceNodeUnion) => void;
  removeNodeFromDrawer: () => void;
  isSideDrawerOpen: () => boolean;
  isSideDrawerClosed: () => boolean;
}

export const sideDrawerVar = makeVar<SurfaceNodeUnion | undefined>(undefined);

const sideDrawerOperations: SideDrawerOperations = {
  setNodeToDrawer,
  removeNodeFromDrawer,
  isSideDrawerOpen,
  isSideDrawerClosed,
};

function setNodeToDrawer(node: SurfaceNodeUnion): void {
  sideDrawerVar(node);
}

function removeNodeFromDrawer() {
  sideDrawerVar(undefined);
}

function isSideDrawerOpen(): boolean {
  return Boolean(sideDrawerVar());
}

function isSideDrawerClosed(): boolean {
  return !sideDrawerVar();
}

export function useSideDrawerState(): [
  SurfaceNodeUnion | undefined,
  SideDrawerOperations,
] {
  const state = useReactiveVar(sideDrawerVar);

  return [state, sideDrawerOperations];
}

export function useSideDrawerOperations(): SideDrawerOperations {
  return sideDrawerOperations;
}
